import * as React from 'react';

const Review = ({ ...props }) => (
    <svg
        width="16"
        height="24"
        viewBox="0 0 16 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M12 5.4C13.43 5.4 14.6 6.57 14.6 8V13C14.6 14.43 13.43 15.6 12 15.6H10.6V17.2L8.84 15.88L8.47 15.6H4C2.57 15.6 1.4 14.43 1.4 13V8C1.4 6.57 2.57 5.4 4 5.4H12ZM12 4H4C1.79 4 0 5.79 0 8V13C0 15.21 1.79 17 4 17H8L12 20V17C14.21 17 16 15.21 16 13V8C16 5.79 14.21 4 12 4Z"
            fill="currentColor"
        />
    </svg>
);

export default Review;
